import { useCallback } from 'react';
import { debounce } from 'lodash';
import { Row, Col, Input } from 'antd';
import { useSmallFleets } from '../context/SmallFleets.context';

const { Search } = Input;

const Filters = () => {
    const { handleSearchParam } = useSmallFleets();

    const handleSearch = useCallback(
        debounce((e: any) => {
            const value = e.target.value;
            handleSearchParam('search', value);
        }, 700),
        [handleSearchParam],
    );
    return (
        <Row>
            <Col span={8}>
                <Search
                    allowClear
                    placeholder="Search"
                    onChange={handleSearch}
                />
            </Col>
        </Row>
    );
};

export default Filters;
